import script from "./popupimage.vue?vue&type=script&lang=js"
export * from "./popupimage.vue?vue&type=script&lang=js"

import "./popupimage.vue?vue&type=style&index=0&id=7d8e2154&scoped=true&lang=scss"
import "./popupimage.vue?vue&type=style&index=1&id=7d8e2154&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d8e2154"]])

export default __exports__